import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"right-panel",class:_vm.rightPanelTransitioning && 'transition-width',style:(`width: ${_vm.panelWidth}px`)},[_c('div',{staticClass:"header"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.closePanel}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1),_c('div',{staticClass:"content"},[(_vm.isHelpOpen)?_c('helpPanel'):(_vm.isChangeHistoryOpen)?_c('changeHistory'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }